<template>
  <div>
    <HeadBanner
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <Breadcrumb />
    <HighlightsTabs
      :itemData="
        _.get(this.$store.state.indx, 'terms.financial_highlights_category')
      "
    />
    <HighlightsList
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.HighlightsList.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.HighlightsList.data'
        )
      "
    />
    <div class="policiesListContainer container">
      <div class="policiesListInner mt-144">
        <PoliciesDownloadList
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.PoliciesList.conf.enabled'
            ) == 1
          "
          :itemData="
            _.get(this.$store.state.current_content, 'secondary.PoliciesList')
          "
        />
        <PoliciesBanner
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.PoliciesBanner.conf.enabled'
            ) == 1
          "
          :itemData="
            _.get(this.$store.state.current_content, 'secondary.PoliciesBanner')
          "
        />
      </div>
    </div>
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import HighlightsTabs from "@/components/HighlightsTabs";
import HighlightsList from "@/components/HighlightsList";
import PoliciesBanner from "@/components/PoliciesBanner";
import PoliciesDownloadList from "@/components/PoliciesDownloadList";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    HighlightsTabs,
    HighlightsList,
    PoliciesBanner,
    PoliciesDownloadList,
  },
};
</script>